import {
  paginateDescribeSpotPriceHistory,
  EC2Client,
  SpotPrice,
} from "@aws-sdk/client-ec2";
import { getAuthToken } from "./getAuthToken";
import { fromWebToken } from "@aws-sdk/credential-providers";
import { getDefaultRoleAssumerWithWebIdentity } from "@aws-sdk/client-sts";
import { getFromLocalStorage, setLocalStorage } from "../utils/localStorage";
import { regions } from "../consts/regions";

export const getRegionSpotPricesByInstanceType = async (
  region: string,
  instanceType: string,
): Promise<SpotPrice[]> => {
  const cacheKey = `spotPricesByInstance/${region},${instanceType}`;

  const cache = await getFromLocalStorage<SpotPrice[]>(cacheKey);

  if (cache !== undefined) {
    return cache;
  }

  const { Token, IdentityId } = await getAuthToken();

  const ec2Client = new EC2Client({
    region,
    credentials: fromWebToken({
      roleArn:
        "arn:aws:iam::573586820653:role/service-role/RegionPriceCompareAnonRole",
      webIdentityToken: Token,
      roleSessionName: IdentityId.substring(IdentityId.indexOf(":") + 1),
      roleAssumerWithWebIdentity: getDefaultRoleAssumerWithWebIdentity(),
    }),
  });

  try {
    const paginator = paginateDescribeSpotPriceHistory(
      { client: ec2Client, pageSize: 1000 },
      {
        InstanceTypes: [instanceType],
        StartTime: new Date(),
        EndTime: new Date(),
        MaxResults: 10000000,
      },
    );

    let spotPrices = [];

    for await (const page of paginator) {
      if (page.SpotPriceHistory && page.SpotPriceHistory.length) {
        spotPrices.push(
          ...page.SpotPriceHistory.map(
            ({
              SpotPrice,
              ProductDescription,
              AvailabilityZone,
              InstanceType,
            }) => ({
              SpotPrice,
              ProductDescription,
              AvailabilityZone,
              InstanceType,
            }),
          ),
        );
      }
    }

    console.log(spotPrices);

    await setLocalStorage({
      key: cacheKey,
      value: spotPrices,
      expiryMs: 1000 * 60 * 5,
    });

    return spotPrices;
  } catch (e) {
    return [];
  }
};

export const getSpotPricesByInstanceType = async (
  ec2Client: EC2Client,
  instanceType: string,
): Promise<SpotPrice[]> => {
  let spotPricesDataByRegion = await Promise.all(
    regions.map((region) =>
      getRegionSpotPricesByInstanceType(region, instanceType),
    ),
  );

  return spotPricesDataByRegion.reduce(
    (acc: SpotPrice[], regionSpotPriceData) => {
      acc.push(...regionSpotPriceData);
      return acc;
    },
    [],
  );
};
